module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/multiplex/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 288
// module chunks = 0